import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import smashSound from './Module4Audio/smash.mp3';
import './PosturePractice.scss';
import { GetUserVideo, getVideo } from './../../s3Func/s3Download';
import { CloudfrontVideoFormat } from '../../videos/CloudfrontVideoFormat';
import { API } from 'aws-amplify';
import MediaService from '../../services/MediaService';
import { sleep } from '../../utils';

/**
 *  Creates and runs the practice section for Unit1 Module4
 *  Note: This code is reused in other modules as well
 * @param {*} props
 * @returns the HTML code for the practice section.
 */
const PosturePractice = (props) => {
  // Initialize variables and states here
  const [background4, setBackground4] = useState(props.background);
  const dispatch = useDispatch();
  const [practiceVideo, setPracticeVideo] = useState(false);
  const [practice, setPractice] = useState(false);
  const [practiceCount, setPracticeCount] = useState(1);

  const { login } = useSelector((state) => state.loginReducer, shallowEqual);

  const monkeyStill = MediaService.getImage(
    '/Module4Images/Monkey+Practice+still.gif',
    login
  );
  const practiceCorrectAudio = MediaService.getVideo(
    '/Module4Videos/practice_correct.mp3',
    login
  );
  const practiceIncorrectAudio = MediaService.getVideo(
    '/Module4Videos/practice_incorrect.mp3',
    login
  );
  const practiceDoneAudio = MediaService.getVideo(
    '/Module4Videos/practice_done.mp3',
    login
  );
  const ExitBtn = MediaService.getImage('/Images/close.png', login);

  const goodPostureImages = useMemo(
    () => [
      'appfiles/posture/day-1-good-posture.jpg',
      'appfiles/posture/day-2-good-posture.jpg',
      'appfiles/posture/day-3-good-posture.jpg',
    ],
    []
  );
  const badPostureImages = useMemo(
    () => [
      'appfiles/posture/day-1-bad-posture.jpg',
      'appfiles/posture/day-2-bad-posture.jpg',
      'appfiles/posture/day-3-bad-posture.jpg',
    ],
    []
  );

  const [image1, setImage1] = useState(null);
  const [image2, setImage2] = useState(null);
  const [monkeyState, setMonkeyState] = useState(monkeyStill);

  const [leftImageID, setLeftImageID] = useState('');
  const [rightImageID, setRightImageID] = useState('');

  const [correctImageNum1, setCorrectImageNum1] = useState(null);

  const [practiceCorrect, setPracticeCorrect] = useState(false);
  const [practiceIncorrect, setPracticeIncorrect] = useState(false);
  const [practiceDone, setPracticeDone] = useState(false);

  const [intro, setIntro] = useState('');

  const [displayPracticeVideo, setDisplayPracticeVideo] = useState();

  const [isPracticing, setIsPractice] = useState(false);

  const [firstTime, setFirstTime] = useState(true);
  const [score, setScore] = useState(0);
  

  const [monkeyCorrectGif, setMonkeyCorrectGif] = useState(monkeyStill);
  const [monkeyIncorrectGif, setMonkeyIncorrectGif] = useState(monkeyStill);
  const [monkeyDoneGif, setMonkeyDoneGif] = useState(monkeyStill);

  // Always-mounted UI audio for iOS reliability
  const uiAudioRef = useRef(null);
  const expectedUiSrcRef = useRef('');
  const uiEndActionRef = useRef(null);
  const [uiVoiceSrc, setUiVoiceSrc] = useState('');
  const [uiShouldPlay, setUiShouldPlay] = useState(false);

  // Initially grabs the gifs that will allow the monkey to talk during practice
  const getGifs = async () => {
    const correctGif = await getVideo(
      'appfiles/posture/monkey_practice_correct.gif', login
    );
    setMonkeyCorrectGif(correctGif);

    const incorrectGift = await getVideo(
      'appfiles/posture/monkey_practice_incorrect.gif', login
    );
    setMonkeyIncorrectGif(incorrectGift);

    const donePracticeVideo = await getVideo(
      'appfiles/posture/monkey_practice_done.gif', login
    );
    setMonkeyDoneGif(donePracticeVideo);
  }

  const getPracticeVideo = async () => {
    const module9Completed = props.stepComplete === 'MODULE9_SET_stepCompleted';
    let video = '';

    if (!props.unit4) {
      if (props.module.currentday === 1) {
        video = module9Completed
          ? 'aabca36498af2d92d4a6db9a4c2b/480.m3u8'
          : '9d8ffe8d71fa53dbbb5a213676a3/480.m3u8';
      }
  
      if (props.module.currentday === 2) {
        video = module9Completed
          ? '2e711915d48e151761f21ce4b594/480.m3u8'
          : 'a624b554612a05c4e5c8912c3cff/480.m3u8';
      }
  
      if (props.module.currentday === 3) {
        video = module9Completed
          ? '9648ceed66b5002e1913ad73478c/480.m3u8'
          : '7e0e8fa99ce3a04cf23fe83190f8/480.m3u8';
      }
  
      if (props.module.currentday > 3) {
        video = await GetUserVideo(
          `influencers/${login.influencerid}/posture_video_message.mp4`
        );
      }
      if (props.world2) {
        const data = await getVideo('appfiles/posture/review_practice_intro.mp3', login);
        setIntro(data);
      } else {
        const data = await getVideo('appfiles/posture/practice_intro.mp3', login);
        setIntro(data);
      }
      setDisplayPracticeVideo(video);
      setPracticeVideo(true);

    }
    else{
      const data = await getVideo('appfiles/posture/practice_intro.mp3', login);
      setIntro(data);
      onPracticeVideoEnd()
    }
    
  }

  // Randomly decide which picture will be the correct answer.
  const createImages = async () => {
    setFirstTime(true);

    const { floor, random } = Math;
    const randomImage = floor(random() * 3);
    const randomNum = floor(random() * 2);

    const goodPosture = await getVideo(goodPostureImages[randomImage], login);
    const badPosture = await getVideo(badPostureImages[randomImage], login);

    setImage1(randomNum === 2 ? goodPosture : badPosture);
    setImage2(randomNum === 2 ? badPosture : goodPosture);
    setCorrectImageNum1(randomNum === 2 ? 1 : 2);
  }

  // Decide whether the correct image was clicked on and reset if it wasn't
  const GameDesign = async (imageNum) => {
    if (!isPracticing) {
      setIsPractice(true);
      setIntro(null);
      if (imageNum === correctImageNum1) {
        setPracticeCorrect(true);
      } else {
        setScore(-1);
        setPracticeIncorrect(true);
      }
    }
  };

  // Play the monkey talking if the image was correctly clicked on.
  const doAnimation = () => {
    setLeftImageID('correctAnswerX');
    setRightImageID('correctAnswerX');
  };

  const handleBackAnimation = () => {
    props.setDisplayPractice(false);
  };

  const onCorrectAudioEnd = async () => {
    setPracticeCorrect(false);
    await sleep(500);
    doAnimation();
    playUiAudio(smashSound);
    doAnimation();
    await sleep(2000);
    setPracticeDone(true);
    await sleep(4000);
    setPracticeCorrect(false);
  };

  const onIncorrectAudioEnd = async () => {
    setPracticeIncorrect(false);
    setIsPractice(false);
  };

  const onPracticeDoneAudioEnd = async () => {
    try {
      await API.post('TIR', '/v3/student/result', {
        body: {
          student_id: login.studentid,
          metric: 'practice_posture',
          result: JSON.stringify({
            day: module.currentday,
            created: new Date().toISOString(),
            review: props.world2 ? 1 : 0,
            values: [{ value: 1 + score, target: 1 }],
          }),
        },
      });
    } catch (error) {
      console.log(error);
    }
    if (!props.unit4) {
      if (!props.module.reviewIcon) {
        dispatch({ type: props.stepComplete, payload: 'practice' });
      }
    }
    else{
      props.next()
    }
    props.module.sectionCompleted = props.module.sectionCompleted + 1
    props.setDisplayPractice(false);
  };

  const onPracticeVideoEnd = async () => {
    setPracticeVideo(false);
    setPractice(true);
  };

  const onImageSelect = (type) => {
    setIntro(null);
    let imageNumber = 1;
    let setId = setLeftImageID;

    if (!isPracticing) {
      if (type === 'right') {
        imageNumber = 2;
        setId = setRightImageID;
      }

      setId('bouncePress');
      GameDesign(imageNumber);
    }
  };

  // Decide which video to play for practice based on the day.
  useEffect(() => {
    createImages();
    getPracticeVideo();
    getGifs();
  }, []);

  // Play intro voice when present
  useEffect(() => {
    if (practice && intro) {
      playUiAudio(intro, () => setIntro(null));
    }
  }, [practice, intro]);

  // Helper to programmatically play UI audio with optional end action
  const playUiAudio = useCallback(async (src, onEndedAction = null, restartIfSame = true) => {
    if (src && typeof src.then === 'function') {
      src = await src;
    }
    const el = uiAudioRef.current;
    const currentSrc = el ? (el.currentSrc || el.src) : '';
    const same = !!currentSrc && currentSrc.includes(src);
    expectedUiSrcRef.current = src;
    uiEndActionRef.current = onEndedAction;
    if (el && same) {
      if (!restartIfSame) return;
      try {
        el.pause();
        el.currentTime = 0;
        await el.play();
      } catch (e) {
        const msg = String(e && e.message ? e.message : e);
        if (!msg.includes('interrupted by a new load request')) {
          console.log('posture ui audio replay failed', e);
        }
      }
    } else {
      setUiVoiceSrc(src);
      setUiShouldPlay(true);
    }
  }, []);

  // The HTML code for the practice section.
  return (
    <>
      {/* Always-mounted UI audio element for posture practice */}
      <audio
        ref={uiAudioRef}
        src={uiVoiceSrc}
        preload='auto'
        playsInline
        onLoadedData={() => {
          const el = uiAudioRef.current;
          if (!el) return;
          const expected = expectedUiSrcRef.current;
          const currentSrc = el.currentSrc || el.src;
          if (!expected || (currentSrc && !currentSrc.includes(expected))) return;
          if (!uiShouldPlay) return;
          el.currentTime = 0;
          el.play().catch((e) => {
            const msg = String(e && e.message ? e.message : e);
            if (!msg.includes('interrupted by a new load request')) {
              console.log('posture ui audio play failed', e);
            }
          });
        }}
        onEnded={() => {
          const action = uiEndActionRef.current;
          uiEndActionRef.current = null;
          setUiShouldPlay(false);
          if (typeof action === 'function') action();
        }}
      />

      {practiceVideo && (
        <CloudfrontVideoFormat
          source={displayPracticeVideo}
          back='/posture'
          close={props.setDisplayPractice}
          background={background4}
          ended={onPracticeVideoEnd}
        />
      )}

      {practice && (
        <div
          className='U1_M2practice'
          style={{ backgroundImage: `url(${background4})` }}
        >
          <header>
            <h2>Select the photo which shows good posture</h2>
            <button className='close-btn' onClick={handleBackAnimation}>
              <img alt='' src={ExitBtn} />
            </button>
          </header>
          <div className='PosturePractice'>
            <div className='PosturePractice__photos'>
              <button id={leftImageID} onClick={() => onImageSelect('left')}>
                <img src={image1} alt='practice 1' />
              </button>

              <button id={rightImageID} onClick={() => onImageSelect('right')}>
                <img src={image2} alt='practice 2' />
              </button>
            </div>
          </div>
          <div className='posture_monkey'>
            <figure>
                <img
                  alt=''
                  src={monkeyStill}
                />
            </figure>
            <figure>
                {practiceIncorrect && <img
                  alt=''
                  src={monkeyIncorrectGif}
                  onLoad={()=>{  
                    playUiAudio(practiceIncorrectAudio, onIncorrectAudioEnd)
                  }}
                />}
                {practiceCorrect && <img
                  src={monkeyCorrectGif}
                  alt=''
                  onLoad={()=>{  
                    playUiAudio(practiceCorrectAudio, onCorrectAudioEnd)
                  }}
                />}
                {practiceDone && <img
                  alt=''
                  src={monkeyDoneGif}
                  onLoad={()=>{  
                    playUiAudio(practiceDoneAudio, onPracticeDoneAudioEnd)
                  }}
                />}
              </figure>
            </div>
        </div>
      )}
    </>
  );
};
export default PosturePractice;
